// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__b8V8-","info":"Footer_info__68utD","newdle":"Footer_newdle__EekT2","cern":"Footer_cern__4QVJd","links":"Footer_links__3673g","link":"Footer_link__e5-Fl"};